<template>
    <div v-if="interview" :class="cssClass">
        <b-form-row>
            <b-form-group label="Interview"
                          label-for="interviewDisplayName"
                          class="col-md-6">
                <b-input-group>
                    <b-form-input name="interviewDisplayName"
                                  :value="interview.displayName"
                                  readonly>
                    </b-form-input>
                    <b-input-group-append>
                        <b-button variant="outline-secondary" title="Glossary" :href="$urlHelper.getPageUrl('ElectronicGlossary', [interviewId])" target="_blank"><i class="fas fa-book mr-1"></i></b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
            <b-form-group label="Organisation"
                          label-for="interviewOrganisation"
                          class="col-md-4">
                <b-form-input name="interviewOrganisation"
                              :value="interview.interviewOrganisation.name"
                              readonly>
                </b-form-input>
            </b-form-group>
            <b-form-group label="Length"
                          label-for="interviewLength"
                          class="col-md-2">
                <b-form-input name="interviewLength"
                              :value="formatSecondsAsDuration(interview.lengthInSeconds)"
                              readonly>
                </b-form-input>
            </b-form-group>
        </b-form-row>
        <b-form-row v-if="details != 'min' && interview.matterOrCaseReference">
            <b-form-group label="Title of related matter or case"
                          label-for="interviewMatterOrCaseReference"
                          class="col-md-6">
                <b-form-input name="interviewMatterOrCaseReference"
                              :value="interview.matterOrCaseReference"
                              readonly>
                </b-form-input>
            </b-form-group>
        </b-form-row>
        <interview-parties title="Interviewer/s"
                           disabled
                           :parties="interview.interviewers"
                           class="mb-2"
                           v-if="details == 'all'">
        </interview-parties>
        <interview-parties title="Interviewee/s"
                           disabled
                           :parties="interview.interviewees"
                           class="mb-2"
                           v-if="details == 'all'">
        </interview-parties>
        <b-form-row v-if="details == 'all'">
            <b-form-group label="Audio Assessment"
                          label-for="audioAssessment"
                          class="col-md-4">
                <b-form-input name="audioAssessment"
                              :value="interview.audioAssessmentDisplayText"
                              readonly>
                </b-form-input>
            </b-form-group>
        </b-form-row>
    </div>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import axios from 'axios';

    import ErrorsMixin from '../mixins/ErrorsMixin';
    import DateTimeMixin from '../mixins/DateTimeMixin';
    import InterviewParties from './InterviewParties';

    Vue.use(BootstrapVue);
    Vue.component('interview-parties', InterviewParties);

    export default {
        name: 'InterviewDetails',
        mixins: [ErrorsMixin, DateTimeMixin],
        props: {
            apiUrl: {
                type: String,
                required: true
            },
            interviewId: {
                type: String,
                default: null
            },
            cssClass: {
                type: String,
                default: null
            },
            details: {
                type: String,
                default: 'all',
                validator: function (value) {
                    return ['min', 'med', 'all'].includes(value)
                }
            }
        },
        watch: {
            interviewId: function () {
                this.reload();
            }
        },
        data: function () {
            return {
                interview: null
            };
        },
        methods: {
            reload: function () {
                var currentErrors = [];
                if (this.interviewId) {
                    return axios
                        .get(this.apiUrl + '/interview/' + this.interviewId)
                        .then(response => {
                            this.interview = response.data;
                        })
                        .catch(ex => {
                            currentErrors = this.handleAxiosException(ex);
                        })
                        .finally(() => {
                            if (currentErrors.length != 0) {
                                this.showErrorsToast(currentErrors);
                            }
                        });
                }
                return Promise.resolve();
            }
        },
        mounted: function () {
            this.reload();
        }
    }
</script>